import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Disable background scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Projects', path: '/projects' },
    { name: 'Awards', path: '/awards' },
    { name: 'CSR Activity', path: '/csrActivity' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
    { name: 'Become Partner', path: '/becomePartner' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300
        ${location.pathname === '/'
          ? (scrolled ? 'bg-[#011321] shadow-md' : 'bg-transparent')
          : 'bg-[#011321] shadow-md'
        }
      `}
    >
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> */}
      <div className="max-w-7xl">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}

          {!isMobile && (



            <div className='flex'>
              <Link to="/" className="flex items-center focus:outline-none focus:ring-0">
                <div className=" flex items-center">
                  <img
                    // src="/images/M_P[2].png"
                    src="/images/Madhu_logo.png"
                    alt="Madhuprabha Construction"
                    className=" w-44 object-contain"
                  />

                </div>
              </Link>
              {/* <div className="ml-1">
                  <img
                    src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                    alt="Logo"
                    className="w-20 h-20 md:w-25 md:h-25 lg:w-25 lg:h-25 object-contain drop-shadow-lg rounded-full bg-white p-1"
                  />
                </div> */}
              {/* <div className="ml-1">
                  <img
                    src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                    alt="Logo"
                    className="w-20 h-20 md:w-27 md:h-27 lg:w-27 lg:h-27 object-full drop-shadow-lg rounded-full p-1"
                  />
                </div> */}

            </div>
          )}

          {isMobile && (

            <div className='flex'>
              <Link to="/" className="flex items-center focus:outline-none focus:ring-0">
                <div className=" flex items-center ">
                  <img
                    src="/images/M_P[2].png"
                    // src="/images/Mad_Constructions_logo.png"
                    alt="Madhuprabha Construction Logo"
                    className=" w-44 object-contain"
                  />

                </div>
              </Link>
              {/* <div className="ml-1">
                 <img
                    src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                    alt="Logo"
                    className="w-20 md:w-28 lg:w-25 object-contain drop-shadow-lg"
                  />
              
            </div> */}
            </div>
          )}


          {/* Desktop Navigation */}
          <div className="hidden xl:flex  items-center space-x-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`relative px-0 py-1 font-medium transition focus:outline-none focus:ring-0
                  ${isActive(item.path)
                    ? 'text-white font-semibold'
                    : 'text-white hover:text-white'
                  }
                `}
              >
                <span>{item.name}</span>
                {isActive(item.path) && (
                  <span className="absolute -bottom-1 left-0 w-full h-[2px] bg-white rounded-full"></span>
                )}
              </Link>
            ))}
            <div className="ml-1" style={{ position: 'absolute', right: 0 }}>
              <img
                src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                alt="Logo"
                className="w-20 h-20 md:w-27 md:h-27 lg:w-27 lg:h-27 object-full drop-shadow-lg rounded-full p-1"
              />

            </div>
          </div>


          {/* Mobile menu button */}
          <div className="xl:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className={`p-3 rounded-xl transition-colors focus:outline-none focus:ring-0
                ${location.pathname === '/'
                  ? (scrolled ? 'bg-slate-800 text-white' : 'bg-white/10 backdrop-blur-sm text-white border border-white/20')
                  : 'bg-slate-800 text-white'
                }
              `}
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>


        </div>
        {/* <div className="ml-1">
                 <img
                    src="/images/WhatsApp Image 2025-09-13 at 16.54.10_b60a3e66.jpg"
                    alt="Logo"
                   className="w-20 h-20 md:w-27 md:h-27 lg:w-27 lg:h-27 object-full drop-shadow-lg rounded-full p-1"
                  />
              
            </div> */}

        {/* Mobile Navigation - Small menu */}
        {isOpen && (
          <div className="fixed inset-0 z-50 flex flex-col pt-6 bg-[#2a5298] overflow-y-auto">
            {/* Close Button */}
            <div className="flex justify-end px-6">
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 rounded-full bg-white text-[#2a5298] focus:outline-none"
              >
                <X className="w-6 h-6" />
              </button>
            </div>

            {/* Menu Items */}
            <div className="flex flex-col mt-4 mb-6">
              {navItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block px-6 py-3 mx-4 my-1 rounded-lg transition
        ${isActive(item.path)
                      ? 'bg-[#011321] text-white font-semibold'
                      : 'text-white hover:bg-white/20 hover:text-white'
                    }`}
                >
                  {item.name}
                </Link>
              ))}

              {/* Career only in Menu */}
              <Link
                to="/career"
                onClick={() => setIsOpen(false)}
                className={`block px-6 py-3 mx-4 my-1 rounded-lg transition
      ${isActive('/career')
                    ? 'bg-[#011321] text-white font-semibold'
                    : 'text-white hover:bg-white/20 hover:text-white'
                  }`}
              >
                Career
              </Link>
            </div>

          </div>
        )}

      </div>
    </nav>
  );
};

export default Navbar;
